import { ThemeType } from 'src/common/enums';
import DarkHeaderLogo from '../images/logo.webp';
import HeaderLogo from '../images/logo.webp';

const VectorLogo = undefined;

const defaultTheme = ThemeType.LIGHT;
const hasThemeSwitcher = false;
const hasNetworkSwitcher = false;
const hasWhatsappWidget = false;
const hasBanner = true;
const isDisableWalletLogin = false;

const headerLogoSize = 110;
const FooterLogo = HeaderLogo;
const DarkFooterLogo = DarkHeaderLogo;
const footerLogoSize = 0;

export {
  VectorLogo,
  HeaderLogo,
  DarkHeaderLogo,
  headerLogoSize,
  FooterLogo,
  DarkFooterLogo,
  footerLogoSize,
  defaultTheme,
  hasThemeSwitcher,
  hasNetworkSwitcher,
  hasWhatsappWidget,
  hasBanner,
  isDisableWalletLogin,
};
